var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"programs_list",attrs:{"id":"panel_useful"}},_vm._l((_vm.appData.events.data),function(item){return _c('li',{key:item.id},[_c('media-content-item',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }